import React, { useState } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";
import { MdLocationOn, MdEmail, MdPhone, MdAccessTime } from "react-icons/md";
import { MdHandshake, MdSchool, MdNewspaper } from "react-icons/md";
import { GiFarmTractor } from "react-icons/gi";
export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    subject: "",
    message: "",
  });
  const [sent, setSent] = useState(false);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_swnmqet",
        "template_rgqxxvi",
        {
          name: form.name,
          email: form.email,
          company: form.company,
          subject: form.subject,
          message: form.message,
        },
        "jlFB_rw-de9b3ZW0P",
      )
      .then(() => setSent(true))
      .catch(() => alert("Mesaj gönderilemedi, tekrar deneyin."));
  };

  const infoItems = [
    {
      icon: <MdLocationOn size={22} style={{ color: "var(--clr-primary)" }} />,
      label: "Adres",
      value: "Gaziantep, Türkiye",
    },
    {
      icon: <MdEmail size={22} style={{ color: "var(--clr-primary)" }} />,
      label: "E-posta",
      value: "vincorarobotics@gmail.com",
    },
    {
      icon: <MdPhone size={22} style={{ color: "var(--clr-primary)" }} />,
      label: "Telefon",
      value: "+90 (538) 612 29 38",
    },
    {
      icon: <MdAccessTime size={22} style={{ color: "var(--clr-primary)" }} />,
      label: "Çalışma Saatleri",
      value: "Pzt–Cum: 09:00 – 18:00",
    },
  ];

  const topics = [
    {
      icon: <MdHandshake size={28} style={{ color: "var(--clr-primary)" }} />,
      title: "İş Birliği",
      desc: "Ortak proje veya yatırım teklifleri için",
    },
    {
      icon: <GiFarmTractor size={28} style={{ color: "var(--clr-primary)" }} />,
      title: "Pilot Uygulama",
      desc: "Çiftliğinizde demo talep edin",
    },
    {
      icon: <MdSchool size={28} style={{ color: "var(--clr-primary)" }} />,
      title: "Akademik",
      desc: "Araştırma ve tez projeleri",
    },
    {
      icon: <MdNewspaper size={28} style={{ color: "var(--clr-primary)" }} />,
      title: "Basın",
      desc: "Medya sorguları ve röportajlar",
    },
  ];

  return (
    <div className="contact-page page-enter">
      <div className="contact-hero">
        <div className="container">
          <span className="section-label">İletişim</span>
          <h1 className="contact-hero__title">Birlikte Konuşalım</h1>
          <p className="contact-hero__subtitle">
            Sorularınız, iş birliği teklifleriniz veya demo talepleriniz için
            bize ulaşın. En kısa sürede geri döneceğiz.
          </p>
        </div>
      </div>

      <div className="container contact-body">
        {/* Topic cards */}
        <div className="contact-topics">
          {topics.map((t, i) => (
            <div key={i} className="topic-card">
              <span className="topic-card__icon">{t.icon}</span>
              <h3 className="topic-card__title">{t.title}</h3>
              <p className="topic-card__desc">{t.desc}</p>
            </div>
          ))}
        </div>

        <div className="contact-main">
          {/* Form */}
          <div className="contact-form-wrap">
            <h2 className="contact-form-wrap__title">Mesaj Gönderin</h2>
            <p className="contact-form-wrap__sub">
              Formü doldurun, 24 saat içinde yanıt verelim.
            </p>

            {sent ? (
              <div className="form-success">
                <span className="form-success__icon">✅</span>
                <h3>Mesajınız İletildi!</h3>
                <p>En kısa sürede sizinle iletişime geçeceğiz.</p>
                <button
                  className="btn btn-primary"
                  onClick={() => setSent(false)}
                  style={{ marginTop: "16px" }}
                >
                  Yeni Mesaj
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-field">
                    <label>
                      Ad Soyad <span>*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="Adınız"
                      required
                    />
                  </div>
                  <div className="form-field">
                    <label>
                      E-posta <span>*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="ornek@email.com"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label>Şirket / Kurum</label>
                    <input
                      type="text"
                      name="company"
                      value={form.company}
                      onChange={handleChange}
                      placeholder="Şirketiniz (isteğe bağlı)"
                    />
                  </div>
                  <div className="form-field">
                    <label>
                      Konu <span>*</span>
                    </label>
                    <select
                      name="subject"
                      value={form.subject}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Konu seçin...</option>
                      <option value="isbirligi">İş Birliği</option>
                      <option value="pilot">Pilot Uygulama Talebi</option>
                      <option value="akademik">Akademik İş Birliği</option>
                      <option value="basin">Basın / Medya</option>
                      <option value="diger">Diğer</option>
                    </select>
                  </div>
                </div>
                <div className="form-field">
                  <label>
                    Mesajınız <span>*</span>
                  </label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Mesajınızı buraya yazın..."
                    rows={6}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary contact-submit"
                >
                  Mesajı Gönder
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <line x1="22" y1="2" x2="11" y2="13" />
                    <polygon points="22 2 15 22 11 13 2 9 22 2" />
                  </svg>
                </button>
              </form>
            )}
          </div>

          {/* Info sidebar */}
          <div className="contact-info">
            <h2 className="contact-info__title">Bize Ulaşın</h2>
            <div className="contact-info__list">
              {infoItems.map((item, i) => (
                <div key={i} className="contact-info__item">
                  <span className="contact-info__icon">{item.icon}</span>
                  <div>
                    <div className="contact-info__label">{item.label}</div>
                    <div className="contact-info__value">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="contact-info__social">
              <p className="contact-info__social-label">Bizi Takip Edin</p>
              <a
                href="https://www.linkedin.com/company/vector-roboticss/"
                target="_blank"
                rel="noreferrer"
                className="contact-linkedin-btn"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
                LinkedIn'de Takip Et
              </a>
            </div>

            <div className="contact-info__map">
              <div className="contact-map-placeholder">
                <MdLocationOn
                  size={28}
                  style={{ color: "var(--clr-primary)" }}
                />
                <p>Gaziantep Teknopark</p>
                <small>Şehitkamil, Gaziantep</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
